/* global window*/
import { SHARE_BUTTON_CONSTANTS } from './Constants';

export function openSocialLink(target, targetParent) {
    let url = '';

    if (target?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL)) {
        url = target?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL);
    }
    else if (targetParent?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL)) {
        url = targetParent?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL);
    }
    else if (targetParent?.parentElement?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL)) {
        url = targetParent?.parentElement?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL);
    }
    else {
        url = targetParent?.parentElement?.parentElement?.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_URL);
    }

    if (url) {
        window.open(url, '_blank');
    }
}
